export default {
  code: '请输入收到的验证码',
  phone: '手机号',
  step1: '填写用户信息',
  step2: '创建账号和密码',
  step3: '完成注册',
  step4: '关注学校公众号',
  editionTip: '为了您最佳体验，建议您使用较新版本的 Google Chrome 或 Safari 浏览器进行体验',
  editionTip1: '为了您最佳体验，建议您使用 Google Chrome v69.0 或 Safari v10.0 以上版本浏览器进行体验',
  notcie: '温馨提示',
  know: '我知道了',
  index: {
    text1: '家长登录',
    text2: '登录',
    text3: '忘记密码？',
    text4: '重置密码',
    text5: '注册新账号',
    text6: '手机号',
    text7: '密码',
    text8: '老师登录',
    text9: '手机号',
    text13: '手机/邮箱',
    text10: '验证码登录',
    text11: '密码登录',
    text12: 'Office365 账号登录',
    tip: '绑定微信后可使用此功能',
    wxbtn: '家长微信登录',
    logintip: '登录到您的帐户',
    usernameTip: '请输入有效的手机号',
    adminLogin: '管理员登录',
    normalLogin: '普通登录'
  },
  forgetPassword: {
    text1: '修改密码',
    text2: '返回登录',
    text3: '验证身份',
    text4: '重置密码',
    text5: '重置成功',
    text6: '手机号码',
    text7: '验证码',
    text8: '重置密码',
    text9: '确认密码',
    text10: '您的密码已重置',
    text11: '返回登录页面',
    text12: '返回登录',
    text13: '立即登录',
    rightTip1: '输入您的手机号码，验证码将发送到您的手机。',
    rightTip2: '输入并确认您的密码。 您的密码至少应为6-16位。',
    rightTip3: '谢谢，您的密码已被更改！',
    step1Tip1: '验证手机号码或邮箱',
    step1Tip2: '验证',
    step2Tip1: '设置新密码',
    step2Tip2: 'Recovery',
    step3Tip: '新密码设置成功！'
  },
  register: {
    text1: '注册',
    text2: '登录',
    text3: '课程主页',
    text4: '验证电话号码',
    text5: '输入帐户信息',
    text6: '注册成功',
    text7: '新账号注册成功！',
    text8: '扫描以上二维码并订阅学校官方帐户，您就可以查看服务号上的校园参观和评估信息。',
    text9: '完成注册',
    text10: '关注微信公众号',
    text11: '创建账号和密码',
    formtext1: '手机号码',
    formtext2: '验证码',
    formtext3: '邮箱',
    formtext4: '设置密码',
    formtext5: '确认密码',
    formtext6: '国籍',
    formtext66: '请选择',
    formtext7: '名',
    formtext8: '中间名字',
    formtext9: '姓',
    formtext10: '全名',
    formtext11: '性别',
    formtext12: '男性',
    formtext13: '女性',
    indexReg1: '您的帐户已注册',
    indexReg2: '欢迎来到',
    indexReg3: '课程',
    indexReg4: '几秒钟后它会跳转到登录状态',
    rightTip1: '输入手机号码，验证码将发送到您的手机。',
    rightTip2: '输入您的详细信息 比如你的姓名和性别。',
    rightTip3: '已成功注册账号，现在去登录',
    step1Tip1: '手机号码',
    step1Tip2: '验证',
    step2Tip1: '输入您的',
    step2Tip2: '详细信息',
    step3Tip: '注册成功！',
    title: '注册新用户',
    subText: '请输入您的详细信息',
    submit: '完成',
    success: '恭喜您已注册成功！',
    backLogin: '返回登录',
    bindWX: '绑定微信账号',
    bindWXSub: '开启微信快捷登录功能',
    bindNow: '立即绑定',
    removeBind: '解绑',
    binded: '已绑定账号',
    fllow: '关注学校微信服务号',
    fllowSub: '第一时间获取学校动态',
    fllowNow: '立即关注',
    fllowed: '已关注',
    fllowTips: '扫描和订阅Immersion官方帐户，您可以查看您的微信上的校园旅游和评估信息。',
    hasAccount: '已有账号，返回登录',
    sex0: '未知',
    sex1: '男',
    sex2: '女'
  }
}



// WEBPACK FOOTER //
// ./src/views/login/lang/zh.js